export default {
  methods: {
    checkPermissions(permissionsNeeded = [], user) {
      const { role, permissions = [] } = user || this.$auth.user() || {};
      if (role === 'admin') {
        return true;
      }
      return permissions.some(permission => permissionsNeeded.includes(permission));
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/permissions.js